import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import SEO from "@/components/SEO";
import SchemaMarkup from "@/components/SchemaMarkup";
import { seoContent } from "@/config/seo";
import heroBackground from "@/assets/hero-background.webp";
// Import HeroAlt directly (not lazy) since it contains the LCP element
import HeroAlt from "@/components/HeroAlt";
const TalentCategories = lazy(() => import("@/components/TalentCategories"));
const TheProcess = lazy(() => import("@/components/TheProcess"));
const LubyGuarantee = lazy(() => import("@/components/LubyGuarantee"));
const Insights = lazy(() => import("@/components/Insights"));
const GlobalRecognition = lazy(() => import("@/components/GlobalRecognition"));
const TrustedBy = lazy(() => import("@/components/TrustedBy"));
const CallToAction = lazy(() => import("@/components/CallToAction"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <>
      <Helmet>
        {/* Preload LCP image for immediate discovery - using dynamic import path */}
        <link rel="preload" as="image" href={heroBackground} fetchPriority="high" />
      </Helmet>
      <SEO {...seoContent["/"]} />
      <SchemaMarkup type="Organization" />
      <SchemaMarkup type="WebSite" />
      <div
        className="min-h-screen bg-background"
        style={{
          backgroundImage: `url(${heroBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          // Removed backgroundAttachment: "fixed" for better performance and Speed Index
        }}
      >
        <Navigation />
        <main className="pt-20">
          {/* HeroAlt is not lazy-loaded to ensure LCP image is detectable in initial HTML */}
          <HeroAlt />

          <div className="bg-white">
            <Suspense fallback={null}>
              <TrustedBy />
            </Suspense>
          </div>

          <div className="bg-gray-50">
            <Suspense fallback={null}>
              <TalentCategories />
            </Suspense>
          </div>

          <div className="bg-white">
            <Suspense fallback={null}>
              <TheProcess />
            </Suspense>
          </div>

          <div className="bg-gradient-to-b from-white to-gray-50">
            <Suspense fallback={null}>
              <LubyGuarantee />
            </Suspense>
          </div>

          <div className="bg-white">
            <Suspense fallback={null}>
              <Insights />
            </Suspense>
          </div>

          <div className="bg-white">
            <Suspense fallback={null}>
              <GlobalRecognition />
            </Suspense>
          </div>

          <div className="bg-gray-900">
            <Suspense fallback={null}>
              <CallToAction />
            </Suspense>
          </div>
        </main>
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </div>
    </>
  );
};

export default Index;
